/** Image scale bounds, as a multiple of the cover fit. */
export const IMAGE_SCALE_MIN = 0.25;
export const IMAGE_SCALE_MAX = 4;
export const IMAGE_SCALE_DEFAULT = 1;

/** A stored image scale as a usable factor; absent or invalid is the cover fit. */
export function resolveImageScale(value: unknown): number {
  if (value === undefined || value === null || value === '') return IMAGE_SCALE_DEFAULT;
  const scale = Number(value);
  if (!Number.isFinite(scale) || scale <= 0) return IMAGE_SCALE_DEFAULT;
  return Math.min(IMAGE_SCALE_MAX, Math.max(IMAGE_SCALE_MIN, scale));
}

/**
 * Size of an image that covers a box and is then scaled about its centre:
 * 1 is the cover fit, below 1 reveals more of the image, above 1 zooms in.
 */
export function scaledCoverSize(
  boxWidth: number,
  boxHeight: number,
  imageWidth: number,
  imageHeight: number,
  imageScale: unknown
): { width: number; height: number } {
  if (!(imageWidth > 0) || !(imageHeight > 0)) {
    return { width: boxWidth, height: boxHeight };
  }
  const factor =
    Math.max(boxWidth / imageWidth, boxHeight / imageHeight) *
    resolveImageScale(imageScale);
  return { width: imageWidth * factor, height: imageHeight * factor };
}

const BACKGROUND_IMAGE_SIZE_MAGNITUDE = 4;

/** The smap background image size slider (-1..1, 0 is natural size) as a scale factor (1/4..4). */
export function backgroundImageSizeFactor(value: unknown): number {
  const raw = Number(value);
  const v = Math.max(-1, Math.min(1, Number.isFinite(raw) ? raw : 0));
  if (v < 0) return 1 / (1 - v * (BACKGROUND_IMAGE_SIZE_MAGNITUDE - 1));
  if (v > 0) return 1 + v * (BACKGROUND_IMAGE_SIZE_MAGNITUDE - 1);
  return 1;
}
